import React from 'react';

interface OperationsIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const CrossIconDarkForm: React.FC<OperationsIconProps> = ({
  color = '#111928',
  ...props
}) => {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 13L7.50001 7.00002L1.5 13ZM13.5 1L7.50001 7.00002L13.5 1ZM7.50001 7.00002L1.5 1L7.50001 7.00002ZM7.50001 7.00002L13.5 13L7.50001 7.00002Z"
        fill="#EEF7FF"
      />
      <path
        d="M7.50001 7.00002L13.5 13M1.5 13L7.50001 7.00002L1.5 13ZM13.5 1L7.50001 7.00002L13.5 1ZM7.50001 7.00002L1.5 1L7.50001 7.00002Z"
        stroke="#EEF7FF"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CrossIconDarkForm;
